import {getStates} from './getStates';

export default {
  county: countryCode => getStates(countryCode, 'STATES') || [],
};
